(function ($) {
  Drupal.behaviors.featuresAndBenefitsRowV1 = {
    attach: function (context, settings) {
      var formatter = $('.features-and-benefits_row_v1');
      var featureCollections = [];

      formatter.each(function (i) {
        var thisFormatter = $(this);
        var foundMatch = false;

        $.each(featureCollections, function (i, v) {
          if (v.container === thisFormatter.parent().get(0)) {
            v.features = v.features.add(thisFormatter.get(0));
            foundMatch = true;

            return false;
          }
        });
        if (!foundMatch) {
          featureCollections.push({
            container: thisFormatter.parent().get(0),
            features: $(thisFormatter.get(0)) // building a new jQuery object, instead of using the current one (i.e., thisFormatter)
          });
        }
      });

      $.each(featureCollections, function (i, v) {
        v.features.each(function (i) {
          var thisFormatter = $(this);

          // Add item-x class to thisFormatter and its row     
          thisFormatter.addClass('item-' + i).find('.row').addClass('item-' + i);

          // Find first benefit text
          var firstItem = thisFormatter.find('.row.item-0').find('.benefit-col').find('.benefit'),

            // Assign first benefit to default item
            defaultMsg = firstItem.text(),

            // This will be used to set the height bellow
            parent = thisFormatter.parent(),

            // Get parent position
            // position = parent.position(),

            // Set top position to be used by active benefit section
            // Now we're using a div wrapper (.featbenf_section) around "thisFormatter" set to "position: relative" to get the top position from it which is "0"
            top = '-157px',

            // Set height to be used by active benefit section
            height = '540',
            ext = 'px'; // change to whatever unit is used, e.g.: 'px', 'em', '%'

          // Display default benefit on page load
          if (i === 0) {
          // Inject first benefit into the default benefit
            thisFormatter.parent()
              .css({ 'position': 'relative' })
              .append('<div class="features-and-benefits_row_v1 item-' + i + '"><div class="row"><div style="top:' + top + 'px; height:' + height + ext + ';" class="benefit-col default"><div class="benefit">' + defaultMsg + '</div></div></div></div>')
              .fadeIn();
          }

          // Set first item to active on page load
          thisFormatter.find('.row.item-0').find('.feature-col').find('.feature').addClass('active');
          thisFormatter.find('.row.item-0').find('.benefit-col').toggle();

          // Set fadeIn/Out transition speed
          // Animation speed values: slow, fast or any integer, default is 400. Less than 400 and the animation is faster, greater than 400 and the animation is slower
          var fadeInSpeed = 800,
            fadeOutSpeed = 800;

          // Get each feature's benefit on click
          thisFormatter.find('.row').find('.feature-col').find('.feature').once().on('click', function() {
            var feature = $(this);

            // Set feature to "active" on click
            feature.toggleClass('active');

            // Hide default benefit when clicking on another feature
            thisFormatter.parent().find('.benefit-col.default').fadeOut(fadeOutSpeed);

            // Remove 'active' class from 'this' siblings
            thisFormatter.siblings().find('.row').find('.feature-col').find('.feature').removeClass('active');

            // Show 'this' feature's benefit and set its height and position
            feature.parent().next().fadeIn(fadeInSpeed).css({
              'position': 'absolute',
              'top': top + 'px',
              'right': '0',
              'height': height + ext
            }).find('.benefit').css({
              'overflow': 'visible',
              'height': height + ext
            });

            // Hide other non-active benefits
            thisFormatter.siblings().find('.row').find('.benefit-col').fadeOut(fadeOutSpeed);

            // Set benefit max-height
            thisFormatter.siblings().find('.row').find('.benefit-col').find('.benefit').css({ 'max-height': height + ext });
          });
        });
      });
    }
  };
})(jQuery);
